// extracted by mini-css-extract-plugin
export default {"container":"hZ-z","list":"iZ-z"};